import React from "react";
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { QUDA_COLORS } from "@/config/colors";

const SupplierOrdersModal = ({
  open,
  onClose,
  supplierName,
  orders,
  loading,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="supplier-orders-modal-title"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", md: 600 },
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography
            id="supplier-orders-modal-title"
            variant="h6"
            component="h2"
            sx={{ color: QUDA_COLORS.TEAL_DARK, fontWeight: "bold" }}
          >
            {supplierName} - Orders
          </Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
            <CircularProgress sx={{ color: QUDA_COLORS.TEAL_DARK }} />
          </Box>
        ) : (
          <TableContainer
            component={Paper}
            sx={{ flexGrow: 1, overflow: "auto", maxHeight: "60vh" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ fontWeight: "bold", color: QUDA_COLORS.TEAL_DARK }}
                  >
                    Item Name
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ fontWeight: "bold", color: QUDA_COLORS.TEAL_DARK }}
                  >
                    Order Count
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orders && orders.length > 0 ? (
                  orders.map((order, index) => (
                    <TableRow key={index} hover>
                      <TableCell component="th" scope="row">
                        {order.itemName}
                      </TableCell>
                      <TableCell align="right">{order.orderCount}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No orders found for this supplier in the selected date
                      range.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Modal>
  );
};

export default SupplierOrdersModal;
